import HardwareSerializer from 'eflex/serializers/hardware';

export default class WorkInstructionHardwareSerializer extends HardwareSerializer {}
